import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

// action
import { removeLoading, addLoading } from '../../../commonAction'

const apiGetListServicesRatingByTellers = `${host}admin/exportJSON/tellerServiceRating`

export const getListServicesRatingByTellers = ({
    FromDate,
    ToDate,
    BranchIDs,
    Rating,
    ServiceCode,
    TellerName,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        Rating,
        ServiceCode,
        TellerName,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListServicesRatingByTellers,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_SERVICES_RATING_BY_TELLER,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    Rating,
                    ServiceCode,
                    TellerName,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_SERVICES_RATING_BY_TELLER_ERROR,
            () => false
        )
    }
}

export const exportListServicesRatingByTellers = ({
    FromDate,
    ToDate,
    BranchIDs,
    Rating,
    ServiceCode,
    TellerName,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        Rating,
        ServiceCode,
        TellerName,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListServicesRatingByTellers,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(
                data,
                TellerName
                    ? `${ReportCodeName}-${BranchCodes[0]}-${TellerName}`
                    : `${ReportCodeName}-${BranchCodes[0]}-ALL`
            )
        } else {
            autoDownloadFromBlob(
                data,
                TellerName
                    ? `${ReportCodeName}-${BranchCodes.join('-')}-${TellerName}`
                    : `${ReportCodeName}-${BranchCodes.join('-')}-ALL`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
